import { render, staticRenderFns } from "./RoleGrantMenu.vue?vue&type=template&id=33e9743d&scoped=true&"
import script from "./RoleGrantMenu.vue?vue&type=script&lang=js&"
export * from "./RoleGrantMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e9743d",
  null
  
)

export default component.exports